export default "__VITE_ASSET__DLQPTCSH__"